export const FETCH_CANDIDAT_REQUEST     = "FETCH_CANDIDAT_REQUEST";
export const FETCH_CANDIDAT_SUCCESSFUL  = "FETCH_CANDIDAT_SUCCESSFUL";
export const FETCH_CANDIDAT_FAILURE     = "FETCH_CANDIDAT_FAILURE";

export const UPDATE_CANDIDAT_REQUEST     = "UPDATE_CANDIDAT_REQUEST";
export const UPDATE_CANDIDAT_SUCCESSFUL  = "UPDATE_CANDIDAT_SUCCESSFUL";
export const UPDATE_CANDIDAT_FAILURE     = "UPDATE_CANDIDAT_FAILURE";